import { getUtcDate } from './get-utc-date'

export const getDateOnlyAsJson = (date: string) => {
  if (!date) {
    return undefined
  }

  const output = getUtcDate(new Date(date))
  output.setUTCHours(0, 0, 0, 0)
  return output.toJSON()
}
